import { render, staticRenderFns } from "./auxiliary-account.vue?vue&type=template&id=1b97033c&scoped=true&"
import script from "./auxiliary-account.vue?vue&type=script&lang=js&"
export * from "./auxiliary-account.vue?vue&type=script&lang=js&"
import style0 from "./auxiliary-account.vue?vue&type=style&index=0&id=1b97033c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97033c",
  null
  
)

export default component.exports